import { render, staticRenderFns } from "./reviewFinished.vue?vue&type=template&id=0d61a6a4&scoped=true&"
import script from "./reviewFinished.vue?vue&type=script&lang=js&"
export * from "./reviewFinished.vue?vue&type=script&lang=js&"
import style0 from "./reviewFinished.vue?vue&type=style&index=0&id=0d61a6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d61a6a4",
  null
  
)

export default component.exports